import { LinkIcon } from "@primer/octicons-react";
import { Box, UnderlineNav } from "@primer/react";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AnhChiEm from "./AnhChiEm";
import BoDoiCongAn from "./bdca";
import CanBoNhanVien from "./cbnv";
import PhuHuynh from "./phu-huynh";
type TongHopLayoutProps = {
    ts_hocsinh_id: number,
}
const TongHopLayout = (props: TongHopLayoutProps) => {
    const { tab } = useParams();
    const navigate = useNavigate();
    const [selectedTab, setSelectedTab] = useState<"phuhuynh" | "ace" | "cbnv" | "bdca">("phuhuynh");

    return (
        <Box>
            <UnderlineNav aria-label="tabs">
                <UnderlineNav.Item
                    icon={LinkIcon}
                    aria-current={selectedTab === "phuhuynh" ? "page" : undefined}
                    onClick={() => setSelectedTab("phuhuynh")}
                >
                    Phụ huynh
                </UnderlineNav.Item>
                <UnderlineNav.Item
                    icon={LinkIcon}
                    aria-current={selectedTab === "ace" ? "page" : undefined}
                    onClick={() => setSelectedTab("ace")}
                >
                    Anh chị em
                </UnderlineNav.Item>
                <UnderlineNav.Item
                    icon={LinkIcon}
                    aria-current={selectedTab === "cbnv" ? "page" : undefined}
                    onClick={() => setSelectedTab("cbnv")}
                >
                    Con cán bộ nhân viên
                </UnderlineNav.Item>
                <UnderlineNav.Item
                    icon={LinkIcon}
                    aria-current={selectedTab === "bdca" ? "page" : undefined}
                    onClick={() => setSelectedTab("bdca")}
                >
                    Con bộ đội công an
                </UnderlineNav.Item>
            </UnderlineNav>
            <Box>{selectedTab === "phuhuynh" && <PhuHuynh ts_hocsinh_id={props.ts_hocsinh_id} />}</Box>
            <Box>{selectedTab === "ace" && <AnhChiEm ts_hocsinh_id={props.ts_hocsinh_id} />}</Box>
            <Box>{selectedTab === "cbnv" && <CanBoNhanVien ts_hocsinh_id={props.ts_hocsinh_id} />}</Box>
            <Box>{selectedTab === "bdca" && <BoDoiCongAn ts_hocsinh_id={props.ts_hocsinh_id} />}</Box>

        </Box>
    );
};

export default TongHopLayout;
